import React from 'react';
import './ES.css';
import { NavLink } from 'react-router-dom';
import PageNavigator from "../../../components/PageNavigator";

function ES0() {
  return (
    	<div className='ES'>
    	<PageNavigator group="ES" />
    		<p className='heading1'>Event Studies</p>
            <div style={{ display: "flex", paddingLeft: "10vw"}}>
            <ul className='toc-list'>
                <div className='content-group'>
                    <li><NavLink className='ES-link' to="/corporate_finance/event_studies/basics">Event Study Basics</NavLink></li>
                    <ul className='toc-list'>
                        <li className='ES-content'>Price Reaction to News</li>
                        <li className='ES-content'>Training</li>
                        <li className='ES-content'>Predicted Return</li>
                        <li className='ES-content'>Abnormal Return</li>
                        <li className='ES-content'>Event Window</li>
                        <li className='ES-content'>Cumulative Abnormal Return</li>
                        <li className='ES-content'>Value of the Information</li>
                        <li className='ES-content'>Statistical Inference</li>
                        <li className='ES-content'>Significance Thresholds</li>
                    </ul>
                    <li><NavLink className='ES-link' to="/corporate_finance/event_studies/example">Event Study Example</NavLink></li>
                    <ul className='toc-list'>
                        <li className='ES-content'>Big Pharma Co.</li>
                        <li className='ES-content'>Regression</li>
                        <li className='ES-content'>Predicted Return</li>
                        <li className='ES-content'>Abnormal Return</li>
                        <li className='ES-content'>t-Statistic</li>
                        <li className='ES-content'>Statistical Significance</li>
                    </ul>
                </div>
            </ul>
            </div>
    	<PageNavigator group="ES"/>
        </div>
  );
}

export default ES0;